import { makeAutoObservable } from 'mobx';

export type ExerciseId = {
  variationId: string;
  sourceType?: string;
  sourceId?: string;
  readonly uniqueId: string;
  equals(other?: any): boolean;
};

export function createExerciseId(json?: Partial<ExerciseId>): ExerciseId {
  return makeAutoObservable({
    variationId: json?.variationId ?? '',
    sourceType: json?.sourceType,
    sourceId: json?.sourceId,

    get uniqueId(): string {
      return this.variationId;
    },

    equals(other?: any): boolean {
      if (other === this) return true;
      return other?.variationId === this.variationId;
    },
  });
}
